/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionOssStatsData } from './SubscriptionOssStatsData';
import {
    SubscriptionOssStatsDataFromJSON,
    SubscriptionOssStatsDataFromJSONTyped,
    SubscriptionOssStatsDataToJSON,
    SubscriptionOssStatsDataToJSONTyped,
} from './SubscriptionOssStatsData';
import type { SubscriptionPaymentSubscriptionHealthData } from './SubscriptionPaymentSubscriptionHealthData';
import {
    SubscriptionPaymentSubscriptionHealthDataFromJSON,
    SubscriptionPaymentSubscriptionHealthDataFromJSONTyped,
    SubscriptionPaymentSubscriptionHealthDataToJSON,
    SubscriptionPaymentSubscriptionHealthDataToJSONTyped,
} from './SubscriptionPaymentSubscriptionHealthData';
import type { SubscriptionVatReviewAdminData } from './SubscriptionVatReviewAdminData';
import {
    SubscriptionVatReviewAdminDataFromJSON,
    SubscriptionVatReviewAdminDataFromJSONTyped,
    SubscriptionVatReviewAdminDataToJSON,
    SubscriptionVatReviewAdminDataToJSONTyped,
} from './SubscriptionVatReviewAdminData';
import type { SubscriptionPaymentFinancialStatsData } from './SubscriptionPaymentFinancialStatsData';
import {
    SubscriptionPaymentFinancialStatsDataFromJSON,
    SubscriptionPaymentFinancialStatsDataFromJSONTyped,
    SubscriptionPaymentFinancialStatsDataToJSON,
    SubscriptionPaymentFinancialStatsDataToJSONTyped,
} from './SubscriptionPaymentFinancialStatsData';
import type { SubscriptionPaymentAdminRowData } from './SubscriptionPaymentAdminRowData';
import {
    SubscriptionPaymentAdminRowDataFromJSON,
    SubscriptionPaymentAdminRowDataFromJSONTyped,
    SubscriptionPaymentAdminRowDataToJSON,
    SubscriptionPaymentAdminRowDataToJSONTyped,
} from './SubscriptionPaymentAdminRowData';
import type { SubscriptionUpcomingPaymentAdminData } from './SubscriptionUpcomingPaymentAdminData';
import {
    SubscriptionUpcomingPaymentAdminDataFromJSON,
    SubscriptionUpcomingPaymentAdminDataFromJSONTyped,
    SubscriptionUpcomingPaymentAdminDataToJSON,
    SubscriptionUpcomingPaymentAdminDataToJSONTyped,
} from './SubscriptionUpcomingPaymentAdminData';

/**
 * 
 * @export
 * @interface SubscriptionPaymentAdminOverviewData
 */
export interface SubscriptionPaymentAdminOverviewData {
    /**
     * 
     * @type {Array<SubscriptionPaymentAdminRowData>}
     * @memberof SubscriptionPaymentAdminOverviewData
     */
    payments?: Array<SubscriptionPaymentAdminRowData>;
    /**
     * 
     * @type {Array<SubscriptionUpcomingPaymentAdminData>}
     * @memberof SubscriptionPaymentAdminOverviewData
     */
    upcomingPayments?: Array<SubscriptionUpcomingPaymentAdminData>;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentAdminOverviewData
     */
    successfulPaymentCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentAdminOverviewData
     */
    failedPaymentCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentAdminOverviewData
     */
    missingPaymentCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentAdminOverviewData
     */
    missingInvoiceCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentAdminOverviewData
     */
    upcomingPaymentCount?: number;
    /**
     * 
     * @type {Array<SubscriptionVatReviewAdminData>}
     * @memberof SubscriptionPaymentAdminOverviewData
     */
    pendingVatReviews?: Array<SubscriptionVatReviewAdminData>;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentAdminOverviewData
     */
    pendingVatReviewCount?: number;
    /**
     * 
     * @type {Array<SubscriptionPaymentFinancialStatsData>}
     * @memberof SubscriptionPaymentAdminOverviewData
     */
    financialStats?: Array<SubscriptionPaymentFinancialStatsData>;
    /**
     * 
     * @type {SubscriptionPaymentSubscriptionHealthData}
     * @memberof SubscriptionPaymentAdminOverviewData
     */
    subscriptionHealth?: SubscriptionPaymentSubscriptionHealthData;
    /**
     * 
     * @type {SubscriptionOssStatsData}
     * @memberof SubscriptionPaymentAdminOverviewData
     */
    ossStats?: SubscriptionOssStatsData;
}

/**
 * Check if a given object implements the SubscriptionPaymentAdminOverviewData interface.
 */
export function instanceOfSubscriptionPaymentAdminOverviewData(value: object): value is SubscriptionPaymentAdminOverviewData {
    return true;
}

export function SubscriptionPaymentAdminOverviewDataFromJSON(json: any): SubscriptionPaymentAdminOverviewData {
    return SubscriptionPaymentAdminOverviewDataFromJSONTyped(json, false);
}

export function SubscriptionPaymentAdminOverviewDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPaymentAdminOverviewData {
    if (json == null) {
        return json;
    }
    return {
        
        'payments': json['payments'] == null ? undefined : ((json['payments'] as Array<any>).map(SubscriptionPaymentAdminRowDataFromJSON)),
        'upcomingPayments': json['upcomingPayments'] == null ? undefined : ((json['upcomingPayments'] as Array<any>).map(SubscriptionUpcomingPaymentAdminDataFromJSON)),
        'successfulPaymentCount': json['successfulPaymentCount'] == null ? undefined : json['successfulPaymentCount'],
        'failedPaymentCount': json['failedPaymentCount'] == null ? undefined : json['failedPaymentCount'],
        'missingPaymentCount': json['missingPaymentCount'] == null ? undefined : json['missingPaymentCount'],
        'missingInvoiceCount': json['missingInvoiceCount'] == null ? undefined : json['missingInvoiceCount'],
        'upcomingPaymentCount': json['upcomingPaymentCount'] == null ? undefined : json['upcomingPaymentCount'],
        'pendingVatReviews': json['pendingVatReviews'] == null ? undefined : ((json['pendingVatReviews'] as Array<any>).map(SubscriptionVatReviewAdminDataFromJSON)),
        'pendingVatReviewCount': json['pendingVatReviewCount'] == null ? undefined : json['pendingVatReviewCount'],
        'financialStats': json['financialStats'] == null ? undefined : ((json['financialStats'] as Array<any>).map(SubscriptionPaymentFinancialStatsDataFromJSON)),
        'subscriptionHealth': json['subscriptionHealth'] == null ? undefined : SubscriptionPaymentSubscriptionHealthDataFromJSON(json['subscriptionHealth']),
        'ossStats': json['ossStats'] == null ? undefined : SubscriptionOssStatsDataFromJSON(json['ossStats']),
    };
}

export function SubscriptionPaymentAdminOverviewDataToJSON(json: any): SubscriptionPaymentAdminOverviewData {
    return SubscriptionPaymentAdminOverviewDataToJSONTyped(json, false);
}

export function SubscriptionPaymentAdminOverviewDataToJSONTyped(value?: SubscriptionPaymentAdminOverviewData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payments': value['payments'] == null ? undefined : ((value['payments'] as Array<any>).map(SubscriptionPaymentAdminRowDataToJSON)),
        'upcomingPayments': value['upcomingPayments'] == null ? undefined : ((value['upcomingPayments'] as Array<any>).map(SubscriptionUpcomingPaymentAdminDataToJSON)),
        'successfulPaymentCount': value['successfulPaymentCount'],
        'failedPaymentCount': value['failedPaymentCount'],
        'missingPaymentCount': value['missingPaymentCount'],
        'missingInvoiceCount': value['missingInvoiceCount'],
        'upcomingPaymentCount': value['upcomingPaymentCount'],
        'pendingVatReviews': value['pendingVatReviews'] == null ? undefined : ((value['pendingVatReviews'] as Array<any>).map(SubscriptionVatReviewAdminDataToJSON)),
        'pendingVatReviewCount': value['pendingVatReviewCount'],
        'financialStats': value['financialStats'] == null ? undefined : ((value['financialStats'] as Array<any>).map(SubscriptionPaymentFinancialStatsDataToJSON)),
        'subscriptionHealth': SubscriptionPaymentSubscriptionHealthDataToJSON(value['subscriptionHealth']),
        'ossStats': SubscriptionOssStatsDataToJSON(value['ossStats']),
    };
}

